import { render, staticRenderFns } from "./DeptSelect.vue?vue&type=template&id=303e1e87&scoped=true"
import script from "./DeptSelect.vue?vue&type=script&lang=js"
export * from "./DeptSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "303e1e87",
  null
  
)

export default component.exports